export default __webpack_public_path__ + "static/kb_3_5-ebcc99bced7fdfcbb2ee572370218883.jpeg";